import React from "react";



const prescriptions = (props) => (
    <div>
        {props.t('preScription.helpPrescription')}
    </div>
);
export default prescriptions;